import React from 'react';
import Reveal from '../lib/Reveal.jsx';
import ContactForm from './ContactForm.jsx';
import { track } from '../lib/analytics.js';

export default function Cta({ tweaks }) {
  return (
    <section id="contact" className="section" style={{ paddingTop: 160, paddingBottom: 160 }}>
      <div className="container">
        <Reveal>
          <div className="section-marker" style={{ marginBottom: 32 }}>
            {tweaks.sectionDividers === 'numbered' ? '07 / Contact' : 'Contact'}
          </div>
        </Reveal>
        <Reveal>
          <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 'clamp(48px, 8vw, 120px)', lineHeight: 0.98, letterSpacing: '-0.035em', margin: 0, textWrap: 'balance', maxWidth: '14ch' }}>
            Tell us what you're <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>trying to ship.</span>
          </h2>
        </Reveal>

        <div className="grid12 cta-row" style={{ marginTop: 64, alignItems: 'start' }}>
          <Reveal style={{ gridColumn: 'span 5' }}>
            <p style={{ fontSize: 18, lineHeight: 1.6, color: 'var(--ink-60)', margin: 0, maxWidth: '40ch' }}>
              We take a small number of engagements per year. If your ambition is real and your timeline is honest, we'd like to hear from you.
            </p>
            <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
              <a href="/book" className="btn btn-primary" onClick={() => track('cta_click', { where: 'cta-section' })}>
                Book a 25-min call <span style={{ fontFamily: 'var(--font-mono)' }}>→</span>
              </a>
            </div>
            <div
              data-testid="contact-caption"
              className="mono-label cta-contact-caption"
              style={{ marginTop: 16, color: 'var(--ink-40)' }}
            >
              — Or send a note{' '}
              <span data-testid="contact-caption-arrow-desktop" className="cta-arrow-desktop">→</span>
              <span data-testid="contact-caption-arrow-mobile" className="cta-arrow-mobile">↓</span>
            </div>
          </Reveal>

          <Reveal style={{ gridColumn: '8 / span 5' }}>
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
